import { useCallback } from "react";

import { api } from "../api.js";

export type S12ApprovalCheckResult = {
  status: "found" | "not-found" | "error";
  surname?: string;
  section12ExpiryDate?: string;
  updated: boolean;
};

export type UseS12ApprovalCheckReturn = {
  check: (userId: string, gmcNumber: string) => Promise<S12ApprovalCheckResult>;
};

const MIN_SPINNER_MS = 1000;

export function useS12ApprovalCheck(): UseS12ApprovalCheckReturn {
  const check = useCallback(
    async (
      userId: string,
      gmcNumber: string,
    ): Promise<S12ApprovalCheckResult> => {
      const startTime = Date.now();

      let outcome: S12ApprovalCheckResult;
      try {
        const response = await api.users.checkS12ApprovalForUser(
          userId,
          gmcNumber,
        );
        outcome = response.data;
      } catch {
        outcome = { status: "error", updated: false };
      }

      const elapsed = Date.now() - startTime;
      if (elapsed < MIN_SPINNER_MS) {
        await new Promise((r) => setTimeout(r, MIN_SPINNER_MS - elapsed));
      }

      return outcome;
    },
    [],
  );

  return { check };
}
